import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Container, Typography, Backdrop, Button, Table, TableBody, TableCell, TableRow, CircularProgress, Card, Box, TableHead, Pagination } from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { ArrowBack } from "@mui/icons-material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from '../../config/firebase';
import fetchData from "../../components/fetchData";
import { getAuth } from "firebase/auth";

const Stats = () => {
    const { id: userId } = useParams();
    const navigate = useNavigate();
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [categoryData, setCategoryData] = useState([]);
    const location = useLocation();

    const [selectedUser, setSelectedUser] = useState(null);
    

    // const selectedUser = location.state?.user;


    const [currentPage, setCurrentPage] = React.useState(1);
    const rowsPerPage = 10; // Number of rows per page
    const bottomRef = useRef(null);
    const columnMapping = {
        projects: ["id", "name", "description", "classTags", "creationTime"],
        keywordsGroup: ["id", "name", "description", "creationTime"],
        keywords: ["id", "name", "group", "projectName", "class", "creationTime"],
        domains: ["id", "domainName", "urlToMonitor", "projectName", "keywords", "template", "siteTitle", "uptime_settings", "lastUptimeCheck", "creationTime"],
        templates: ["id", "name", "description", "creationTime"],
    };

    const fetchUserInfo = async () => {
    try {
        const currentUser = getAuth().currentUser;
        if (!currentUser) throw new Error("User is not logged in.");

        const token = await currentUser.getIdToken();

        const response = await fetch(`${process.env.REACT_APP_CLOUD_FUNCTION_BASE_URL}listUsers`, {
            method: "POST",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId:userId }),
        });

        if (!response.ok) throw new Error(`Fetch failed with status ${response.status}`);

        const data = await response.json();
        if(data.users){
            setSelectedUser(data.users[0]);
        }
            
    } catch (error) {
        console.error("Error fetching user info:", error);
    }
};

    

    const fetchCounts = async () => {
        try {
            const collections = [
                { name: "projects", key: "projectCount" },
                { name: "domains", key: "domainsCount" },
                { name: "keywords", key: "keywordsCount" },
                { name: "keywordsGroup", key: "keywordGroupCount" },
                { name: "templates", key: "templatesCount" },
            ];

            const statsObj = {};
            for (const { name, key } of collections) {
                const colRef = collection(db, name);
                const q = query(colRef, where("userId", "==", userId));
                const snapshot = await getDocs(q);
                statsObj[key] = snapshot.size;
            }

            setStats(statsObj);
        } catch (error) {
            console.error("Error fetching stats:", error);
        }
    };
    console.log("stats:", stats);

    const fetchCountsAPI = async () => {
        console.log("calling fetchcountapi")
        try {
            const collections = [
                { key: "totalActiveCredits", name: "creditsCount" },
                { key: "totalJobs", name: "jobsCount" },
                { key: "totalContents", name: "contentsCount" },
            ];

            const statsObj = {};
            const apiUrl = `${process.env.REACT_APP_API_BASE_URL}xeo/v1/user/stats/${userId}`

            const res = await fetchData({
                url: apiUrl,
            })
            
            const userData = res?.user || {};

            for (const { name, key } of collections) {
                statsObj[name] = userData[key] ?? 0;
            }

            setStats(prev => ({
                ...prev,
                ...statsObj,
            }));
            // setPreviewCategoryData();

        } catch (error) {
            console.error("Error fetching stats from api:", error);
        }
    };

    const handleCategoryClick = async (category) => {
        setLoading(true);
        if (selectedCategory === category) {
            // If the category is already selected, toggle it off
            setSelectedCategory(null);
            setCategoryData([]);
        } else {
            // Otherwise, fetch and display the data
            setCurrentPage(1);
            setSelectedCategory(category);
            try {
                const colRef = collection(db, category);
                const q = query(colRef, where("userId", "==", userId));
                const snapshot = await getDocs(q);
                const data = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
                setCategoryData(data);

                // Scroll to the bottom after setting the data
                setTimeout(() => {
                    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            } catch (error) {
                console.error("Error fetching category data:", error);
            }
        }
        setLoading(false);
    };
    // console.log("CategoryData:", categoryData);

    const handleCategoryClickAPI = async (category) => {
        setLoading(true);
        if (selectedCategory === category) {
            // If the category is already selected, toggle it off
            setSelectedCategory(null);
            // setCategoryData([]);
        } else {
            // Otherwise, fetch and display the data
            setCurrentPage(1);
            setSelectedCategory(category);
            try {
                const apiUrl = `${process.env.REACT_APP_API_BASE_URL}xeo/v1/user/stat/${userId}`

                const res = await fetchData({
                    url: apiUrl,
                })
                // setCategoryData(data);

                // Scroll to the bottom after setting the data
                setTimeout(() => {
                    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                }, 100);
            } catch (error) {
                console.error("Error fetching category data:", error);
            }
        }
        setLoading(false);
    }

    useEffect(() => {
        const loadData = async () => {
            await fetchUserInfo();
            await fetchCounts();
            await fetchCountsAPI();
            setLoading(false);
        };

        loadData();
    }, [userId]);
console.log("selectedUser:", selectedUser);

    if (loading) {
        return (
            <Backdrop open={true} style={{ color: '#fff', zIndex: 1 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        );
    }

    const formatDate = (dateStr) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' };
        const date = new Date(dateStr);
        return new Intl.DateTimeFormat('en-US', options).format(date);
    };

    return (
        <Container maxWidth={false} sx={{ padding: '10px' }}>
            <Typography
                variant="h5"
                gutterBottom
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '15px',
                }}
            >
                <Button
                    onClick={() => navigate(-1)}
                    color="primary"
                    startIcon={<ArrowBack />}
                    sx={{
                        textTransform: 'none',
                        fontSize: '16px',
                        fontWeight: '500',
                    }}
                >
                    Back
                </Button>
                <span>| User's Data</span>
            </Typography>

            {stats && (
                <Box>
                    {/* Selected User's Details */}
                    {selectedUser && (
                        <Card
                            elevation={3}
                            sx={{
                                padding: '20px',
                                backgroundColor: '#ffffff',
                                borderRadius: '10px',
                            }}
                        >
                            <Box sx={{ marginBottom: '20px' }}>
                                <Table maxWidth={false}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ padding: '8px' }}><strong>User ID:</strong></TableCell>
                                            <TableCell sx={{ padding: '8px' }}>{selectedUser.id}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ padding: '8px' }}><strong>Email:</strong></TableCell>
                                            <TableCell sx={{ padding: '8px' }}>{selectedUser.email}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ padding: '8px' }}><strong>Role:</strong></TableCell>
                                            <TableCell sx={{ padding: '8px' }}>{selectedUser.role}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ padding: '8px' }}><strong>Account Created on:</strong></TableCell>
                                            <TableCell sx={{ padding: '8px' }}>{formatDate(selectedUser.creationTime)}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ padding: '8px' }}><strong>Last SignedIn on:</strong></TableCell>
                                            <TableCell sx={{ padding: '8px' }}>{formatDate(selectedUser.lastSignInTime)}</TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Box>
                            <Box
                                sx={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(5, 1fr)', // Five equal-width columns
                                    gap: '20px',
                                }}
                            >
                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'projects' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'pointer',
                                        '&:hover': { backgroundColor: '#e0e0e0' },
                                    }}
                                    onClick={() => handleCategoryClick('projects')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Projects
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.projectCount}
                                    </Typography>
                                </Card>

                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'keywordsGroup' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'pointer',
                                        '&:hover': { backgroundColor: '#e0e0e0' },
                                    }}
                                    onClick={() => handleCategoryClick('keywordsGroup')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Keywords Group
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.keywordGroupCount}
                                    </Typography>
                                </Card>

                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'keywords' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'pointer',
                                        '&:hover': { backgroundColor: '#e0e0e0' },
                                    }}
                                    onClick={() => handleCategoryClick('keywords')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Keywords
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.keywordsCount}
                                    </Typography>
                                </Card>

                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'domains' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'pointer',
                                        '&:hover': { backgroundColor: '#e0e0e0' },
                                    }}
                                    onClick={() => handleCategoryClick('domains')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Domains
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.domainsCount}
                                    </Typography>
                                </Card>

                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'templates' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'pointer',
                                        '&:hover': { backgroundColor: '#e0e0e0' },
                                    }}
                                    onClick={() => handleCategoryClick('templates')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Templates
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.templatesCount}
                                    </Typography>
                                </Card>

                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'jobs' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'default',
                                        '&:hover': {
                                            backgroundColor: selectedCategory === 'jobs' ? '#e0e0e0' : '#f4f6f8',
                                        },
                                    }}
                                // onClick={() => handleCategoryClickAPI('jobs')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Jobs
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.jobsCount}
                                    </Typography>
                                </Card>

                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'contents' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'default',
                                        '&:hover': {
                                            backgroundColor: selectedCategory === 'contents' ? '#e0e0e0' : '#f4f6f8',
                                        },
                                    }}
                                // onClick={() => handleCategoryClickAPI('contents')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Articles
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.contentsCount}
                                    </Typography>
                                </Card>

                                <Card
                                    elevation={2}
                                    sx={{
                                        padding: '15px',
                                        textAlign: 'center',
                                        borderRadius: '10px',
                                        backgroundColor: selectedCategory === 'credits' ? '#e0e0e0' : '#f4f6f8',
                                        cursor: 'default',
                                        '&:hover': {
                                            backgroundColor: selectedCategory === 'credits' ? '#e0e0e0' : '#f4f6f8',
                                        },
                                    }}
                                // onClick={() => handleCategoryClickAPI('credits')}
                                >
                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: '#333' }}>
                                        Credits
                                    </Typography>
                                    <Typography variant="h5" sx={{ margin: '10px 0', color: '#007bff' }}>
                                        {stats.creditsCount}
                                    </Typography>
                                </Card>
                            </Box>
                        </Card>
                    )}
                </Box>
            )}

            {/* Data will be displayed Here... */}
            {selectedCategory && categoryData && categoryData.length > 0 ? (
                <Card
                    elevation={3}
                    sx={{
                        marginTop: '30px',
                        marginBottom: '30px',
                        padding: '20px',
                        backgroundColor: '#ffffff',
                        borderRadius: '10px',
                    }}
                >
                    <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ fontWeight: 'bold', color: '#555' }}
                    >
                        {selectedCategory.charAt(0).toUpperCase() + selectedCategory.slice(1)} Details
                    </Typography>
                    <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '2000px' }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {columnMapping[selectedCategory]?.map((key) => (
                                        <TableCell
                                            key={key}
                                            sx={{ fontWeight: 'bold', fontSize: '14px', color: '#333' }}
                                        >
                                            {key.charAt(0).toUpperCase() + key.slice(1)}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {categoryData
                                    .slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
                                    .map((item, rowIndex) => (
                                        <TableRow hover key={rowIndex}>
                                            {columnMapping[selectedCategory]?.map((key) => (
                                                <TableCell
                                                    key={key}
                                                    sx={{ fontSize: '14px' }}
                                                >
                                                    {["keywords", "uptime_settings"].includes(key) ? (
                                                        <Tooltip
                                                            title={
                                                                <pre
                                                                    style={{
                                                                        fontSize: '12px',
                                                                        whiteSpace: 'pre-wrap',
                                                                        backgroundColor: '#f5f5f5',
                                                                        padding: '10px',
                                                                        borderRadius: '8px',
                                                                        color: '#333',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }}
                                                                >
                                                                    {JSON.stringify(item[key], null, 2)}
                                                                </pre>
                                                            }
                                                            arrow
                                                            placement="top"
                                                        >
                                                            <span
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    padding: '6px 12px',
                                                                    backgroundColor: '#0077b6',
                                                                    color: '#ffff',
                                                                    borderRadius: '4px',
                                                                    fontSize: '14px',
                                                                    fontWeight: 'bold',
                                                                    display: 'inline-block',
                                                                    textAlign: 'center',
                                                                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
                                                                    transition: 'background-color 0.3s, box-shadow 0.3s',
                                                                }}
                                                            >
                                                                JSON
                                                            </span>
                                                        </Tooltip>
                                                    ) : typeof item[key] === 'object' && item[key]?.seconds ? (
                                                        new Date(item[key].seconds * 1000).toLocaleString()
                                                    ) : (
                                                        item[key]?.toString() || ''
                                                    )}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                        <Pagination
                            count={Math.ceil(categoryData.length / rowsPerPage)}
                            page={currentPage}
                            onChange={(event, value) => {
                                setCurrentPage(value);
                                // Scroll to the bottom when page changes
                                setTimeout(() => {
                                    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
                                }, 100);
                            }}
                            color="primary"
                        />
                    </div>
                    <div ref={bottomRef} /> {/* Reference for scrolling */}
                </Card>
            ) : (
                <Typography
                    variant="h6"
                    sx={{
                        color: '#888',
                        textAlign: 'center',
                        marginTop: '20px',
                        fontWeight: 'bold',
                        padding: '10px 20px',
                        borderRadius: '8px',
                        backgroundColor: '#f9f9f9',
                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            backgroundColor: '#f0f0f0',
                            boxShadow: '0 6px 15px rgba(0, 0, 0, 0.2)',
                        },
                    }}
                >
                    {selectedCategory
                        ? `No data available for ${selectedCategory}.`
                        : 'Please select a category from Projects, Keywords Group, Keywords, Domains, or Templates to view the data.'}
                </Typography>
            )}
        </Container>
    );
};

export default Stats;